var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenueEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 143,
    viewBox: "0 0 152 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.654 51.3112C158.277 81.4508 146.249 120.696 123.996 135.702C101.742 150.579 69.5053 141.217 42.6813 121.081C15.8572 100.945 -5.31337 70.1645 1.18214 44.7702C7.67766 19.376 41.8393 -0.503305 74.6777 0.00970933C107.516 0.39447 138.911 21.2998 148.654 51.3112Z",
    fill: "#EEF1F9",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.411 34.3198V108.406H50.5V73.9772L62.9746 61.5026L68.8375 67.3655L91.2233 44.9797L95.4873 49.2437L110.411 34.3198Z",
    fill: "#EEF3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5279 75.3604V13M31.5279 13L25.665 18.8629M31.5279 13L37.3909 18.8629",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 108.939L128.533 108.939M128.533 108.939L122.154 102.543M128.533 108.939L122.154 115.335",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5279 118V98.812",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0876 107.873C67.0876 108.84 67.8711 109.623 68.8376 109.623C69.8041 109.623 70.5876 108.84 70.5876 107.873L67.0876 107.873ZM70.5876 74.8276C70.5876 73.8611 69.8041 73.0776 68.8376 73.0776C67.8711 73.0776 67.0876 73.8611 67.0876 74.8276L70.5876 74.8276ZM67.0876 78.9583C67.0876 79.9248 67.8711 80.7083 68.8376 80.7083C69.8041 80.7083 70.5876 79.9248 70.5876 78.9583L67.0876 78.9583ZM70.5876 87.2198C70.5876 86.2533 69.8041 85.4698 68.8376 85.4698C67.8711 85.4698 67.0876 86.2533 67.0876 87.2198L70.5876 87.2198ZM67.0876 95.4812C67.0876 96.4477 67.8711 97.2312 68.8376 97.2312C69.8041 97.2312 70.5876 96.4477 70.5876 95.4812L67.0876 95.4812ZM70.5876 103.743C70.5876 102.776 69.8041 101.993 68.8376 101.993C67.8711 101.993 67.0876 102.776 67.0876 103.743L70.5876 103.743ZM67.0876 74.8276L67.0876 78.9583L70.5876 78.9583L70.5876 74.8276L67.0876 74.8276ZM67.0876 87.2198L67.0876 95.4812L70.5876 95.4812L70.5876 87.2198L67.0876 87.2198ZM67.0876 103.743L67.0876 107.873L70.5876 107.873L70.5876 103.743L67.0876 103.743Z",
    fill: "#ACC1D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5101 87.5L62.9746 62.0354L68.3046 67.3654L90.1574 45.5126L94.9543 50.3096L120.005 25.2588M120.005 25.2588C120.005 25.2588 120.005 33.8372 120.005 35.9187M120.005 25.2588L109.878 25.2588",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.411 44.9795L110.411 107.873",
    stroke: "#ACC1D4",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5279,
    cy: 90.8175,
    r: 6.77792,
    stroke: "#ACC1D4",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueEmpty);
export default __webpack_public_path__ + "static/media/revenueEmpty.7f240a2d.svg";
export { ForwardRef as ReactComponent };